import React from 'react';
import styled, { css, CSSProperties } from 'styled-components';

import { IluckydrawItem } from '@typings/store/luckydraw.interface';
import { IstoreItem } from '@typings/store/storeItem.interface';
import ItemImgCard from '@components/dataDisplay/Store/ItemImgCard';
import Button from '@components/dataEntry/button/Button';
import WalletPrice, { walletSizeMap } from '@pages/Store/component/WalletPrice';
import { useDocument } from '@nandorojo/swr-firestore';
import { CollectionPath } from '@typings/collections.enum';

const ButtonSec = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: max-content;
  font-size: 14px;
  line-height: 1.5;
`;

const MaterialSec = styled.div<{
  size: keyof typeof walletSizeMap;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 4px 6px;
  border-radius: 8px;
  background-color: var(--cardBackgroundColor);
  border: 1px solid var(--cardLineColor);
  font-size: 13px;

  ${({ size }) => walletSizeMap[size]};
`;

const MaterialInfoSec = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  width: 100%;
`;

const PriceSec = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
`;

type Props = {
  data?: IluckydrawItem;
  handleClick?: (any) => void;
  disabled?: boolean;
  style?: CSSProperties;
  showButton?: boolean;
  size?: 'sm' | 'xl' | 'lg' | 'md' | undefined;
  showMaterial?: boolean;
  showMyWallet?: boolean;
};
function ItemMaterialSec({
  data,
  style,
  handleClick,
  disabled,
  showButton = true,
  size = 'md',
  showMaterial = true,
  showMyWallet = false,
}: Props) {
  const materialItemID = data?.materialItemID;
  const price = data?.price;
  const { data: materialData } = useDocument<IstoreItem>(
    `${CollectionPath.STORE}/${materialItemID}`,
  );

  return (
    <ButtonSec style={style}>
      <MaterialInfoSec>
        {showMaterial && (materialItemID || data?.materialCount) && (
          <MaterialSec size={size}>
            {materialItemID && materialData && (
              <ItemImgCard
                data={materialData}
                style={{ width: 20, height: 20 }}
              />
            )}
            {data?.materialCount && (
              <>
                <span>X</span>
                <span>{data?.materialCount}</span>
              </>
            )}
          </MaterialSec>
        )}
        {price !== undefined && price >= 0 && (
          <WalletPrice
            price={price}
            size={size}
            isAbsolute={false}
            showMyWalet={showMyWallet}
            style={{ width: '100%' }}
          />
        )}
      </MaterialInfoSec>
      {showButton && (
        <Button
          style={{ width: '100%' }}
          size={size}
          onClick={handleClick}
          disabled={disabled}
        >
          {disabled ? '구매 불가' : data?.buttonText || '뽑기'}
        </Button>
      )}
    </ButtonSec>
  );
}

export default ItemMaterialSec;
